// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1HWTu","inputWrap":"CustomTip_inputWrap__17Pmj"};